module.exports = __webpack_public_path__ + "f40c84ddf242a7c0ca3966052be1c05a.jpg";


//////////////////
// WEBPACK FOOTER
// ./client/app/images/reports.jpg
// module id = 11
// module chunks = 1